// apps/client/src/ui/kit/TextField.tsx
import { useId } from 'react';
export function TextField(p: { label: string; value: string; onChange: (v: string) => void; maxLength?: number; placeholder?: string;
  inputMode?: 'text' | 'email' | 'numeric'; autoComplete?: string; autoFocus?: boolean }) {
  const id = useId();
  return (
    <label className="field" htmlFor={id}>
      {p.label}
      <input id={id} value={p.value} maxLength={p.maxLength} placeholder={p.placeholder} inputMode={p.inputMode}
        autoComplete={p.autoComplete} autoFocus={p.autoFocus} onChange={(e) => p.onChange(e.target.value)} />
    </label>
  );
}
